import { useRef, useState } from 'react';
import { useInitializationDataContext } from '../../../context/data-context';
import { useSaveProject } from '../../../hooks';
import { getRegionalConfig } from '../../../regional-config';

export const useAutoSaveProject = () => {
  const [previewGenerated, setPreviewGenerated] = useState(false);
  const isSavingRef = useRef(false);
  const {
    initializedDataState: { data: initializedData },
  } = useInitializationDataContext();
  const { saveProject } = useSaveProject();
  const config = getRegionalConfig();

  const autoSaveProject = async () => {
    if (isSavingRef.current || !config.saveProjects.isSavedProjectsEnabled) return;
    isSavingRef.current = true;
    try {
      // Generate previews if we don't have any
      if (initializedData?.project_type_code !== 'S' && !previewGenerated) {
        await saveProject({
          shouldRestoreCanvas: true,
          showLoadingScreen: false,
          generateFrontPreview: true,
        });
        setPreviewGenerated(true);
      } else {
        await saveProject({
          shouldRestoreCanvas: true,
          showLoadingScreen: false,
          generateFrontPreview: false,
        });
      }
    } finally {
      isSavingRef.current = false;
    }
  };

  return { autoSaveProject };
};
